import { connect } from "react-redux";
import React, { Component } from "react";
import FileProvider from "./fileProvider";
import { ReactTitle } from "react-meta-tags";
import { withTranslation } from "react-i18next";
import ManualProvider from "../../shared/provider/manualProvider";
import { getNumberApprovals } from "../../utils/functions";

/*Imports de iconos del diseño */
import contactProvider from "../../../../static/images/contactProvider.svg";
import AddContact from "../../../../static/images/add-contact.svg";
import UploadFile from "../../../../static/images/upload.svg";

import MainTemplate from "../mainTemplate";

import AlertBanner from 'canvas-core-react/lib/AlertBanner';
import { MOD_PROVID } from "../../../permissions";
import { getModules } from "../../../Redux/reducer/clients";
import { getCurrencies } from "../../../Redux/reducer/credit-line";
import { getSessionInfo } from "../../../Redux/reducer/session";
import { getCustomerCreditLine } from "../../../Redux/actions/credit-line";
import { getAuthenticatedClientModules } from "../../../Redux/actions/clientActions";

export class NewProvider extends Component {
  constructor(props) {
    super(props);
    this.state = { manualProvider: true, firstLoad: true, needToken: false };
  }

  componentDidMount() {
    this.props.getModules().then(() => this.updateNeddToken());
    if( this.props.currencies.length <= 0 ) {
      this.props.getCreditLine();
    }
  }

  updateNeddToken() {
    var approvals = getNumberApprovals(this.props.clientModules, MOD_PROVID);
    if (approvals <= 0) {
      this.setState({ needToken: true });
    }
  }

  render() {
    const { t } = this.props;

    return (
      <MainTemplate className="providers-container">
        <ReactTitle title={`${t('providers.addLbl')} - ${t('appName')}`} />
        <div className="container-add">
          <div className="row">
            <div className="col-4">
              <div className="actions-title">
                <img src={contactProvider} className="icon" />
                <p>{t(`providers.new.title`)}</p>
              </div>
              <div
                className="btn-actions manual-load"
                onClick={() =>
                  this.setState({ manualProvider: true, firstLoad: false })
                }
              >
                <img src={AddContact} className="img" />
                <p>{t(`providers.new.manual`)}</p>
              </div>
              <div
                className="btn-actions file-load"
                onClick={() =>
                  this.setState({ manualProvider: false, firstLoad: false })
                }
              >
                <img src={UploadFile} className="img" />
                <p>{t(`providers.new.file`)}</p>
              </div>
            </div>
            <div className="col-8">
              { this.props.session.allCompanies === true ?
                <AlertBanner type={'info'} title={`Agregar proveedor:`} >
                  Para agregar un proveedor es necesario seleccionar una empresa para poder continuar
                </AlertBanner>
                : !this.state.firstLoad ? (
                  this.state.manualProvider ? (
                    <ManualProvider needToken={this.state.needToken} />
                  ) : (
                    <FileProvider needToken={this.state.needToken} />
                  )
                ) : null
              }
            </div>
          </div>
        </div>
      </MainTemplate>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    clientModules: getModules(state),
    currencies: getCurrencies(state),
    session: getSessionInfo(state)
  };
};

export const mapDispatch = (dispatch) => {
  return {
    getModules: () => dispatch(getAuthenticatedClientModules()),
    getCreditLine: () => dispatch(getCustomerCreditLine())
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(withTranslation()(NewProvider));
